<template>
  <div :class="[deviceType, 'inner']">
    <!-- <p>AEON Platinum Visa Card</p> -->
    <div class="content">
      <img
        :class="[deviceType, 'cardImg']"
        src="../../../../assets/icons/CardApplicationNotQualify.svg"
      />
      <!-- <div class="popup-sign">
        <AcknowledgementDeclinedSvg></AcknowledgementDeclinedSvg>
      </div> -->
    </div>
  </div>

  <div class="top-up-successful">
    {{ t("ccOnBoarding.cardListing.unsuccessful") }}
  </div>
  <div :class="[deviceType, 'wallet-limit-up-to-m']">
    {{ t("ccOnBoarding.cardListing.notQualify") }}
  </div>

  <p :class="[deviceType, 'unsucessful-card-header']">
    {{ t("ccOnBoarding.cardListing.title") }}
  </p>
  <p :class="[deviceType, 'desc']" style="font-size: 16px">
    {{ t("ccOnBoarding.cardListing.recommendation3") }}
  </p>

  <div :class="[deviceType, 'products']">
    <div
      class="singleProduct"
      v-for="(product, index) in products"
      :key="index"
    >
      <p class="productName">{{ product.name }}</p>
      <!-- <p class="productInfo">{{ product.info }}</p> -->
      <button class="findOutMore" @click="goToPage(product.link)">
        {{ t("ccOnBoarding.cardListing.findOutMore") }}
        <template v-if="index == 0 || index == 3 || index == 4">
          <img
            style="width: 16px; height: 16px"
            class="path-65"
            src="../../../../assets/icons/Arrow_right_1.svg"
          />
        </template>
        <template v-else>
          <img
            style="width: 11px; height: 10px"
            class="path-65"
            src="../../../../assets/icons/Arrow_right_2.svg"
          />
        </template>
      </button>
    </div>
  </div>

  <div
    v-if="prop.type != 'PF_CC' && prop.type != 'EP_CC'"
    :class="[deviceType, 'buttoncontainer']"
  >
    <div :class="[deviceType, 'left-button']" @click="back()">
      {{ t("ccOnBoarding.back") }}
    </div>
    <!-- <button
      :class="[deviceType, 'right-button']"
      :disabled="isBtnDisabled"
      @click="jump()"
    >
      {{ t("ccOnBoarding.next") }}
    </button> -->
  </div>
</template>

<script setup lang="ts">
import {
  ref,
  onMounted,
  computed,
  onBeforeMount,
  type PropType,
  watch,
} from "vue";

import i18n from "@/plugin/i18n";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import { deviceDetect } from "mobile-device-detect";
import { inject } from "vue";

interface Product {
  name: string;
  link: string;
}

const products = ref<Product[]>([
  {
    name: "Personal Financing",
    link: "https://myaeoncredit.com.my/financing/personal-financing/",
  },
  {
    name: "Motorcycle Financing HP-i",
    link: "https://myaeoncredit.com.my/financing/motorcycle-financing/",
  },
  {
    name: "Auto Financing HP-i",
    link: "https://myaeoncredit.com.my/financing/auto-financing/",
  },
  {
    name: "Objective Financing",
    link: "https://myaeoncredit.com.my/financing/objective-financing/",
  },
  {
    name: "Insurance",
    link: "https://myaeoncredit.com.my/financing-and-services/insurance/",
  },
  {
    name: "SME Financing",
    link: "https://myaeoncredit.com.my/financing-and-services/sme-financing/",
  },
]);

const deviceType = inject("deviceType");

if (deviceType == "d") {
}
const { t } = i18n.global;

const eligibility = ref(true);
const prop = defineProps({
  type: {
    type: String,
  },
});

//List
const titleList = ref([]);
const relationshipList = ref([]);
const mobileCountryCodeList = ref([]);

onBeforeMount(() => {
  MasterService.getMasterData()
    .then((res) => {
      titleList.value = res.data.titleType;
      relationshipList.value = res.data.relativeType;
      mobileCountryCodeList.value = res.data.mobileNoCountryCode;
    })
    .catch((e) => {});
});

const schema = computed(() => {
  return true;
});

const onInvalidSubmit = () => {};

// const isBtnDisabled = computed(() => {
//   return cards.value.findIndex((x) => x.selected) < 0;
// });

const emit = defineEmits(["nextStep", "jumpStep", "submit", "setCardId"]);
const onSubmit = () => {
  emit("submit");
};

const goToPage = (link: string) => {
  window.location.href = link;
};

// const handleBack = () => {
//   emit("previousStep");
// };

// const jump = () => {
//   emit("setCardId", selectedCard.value?.cardId);
//   window.history.replaceState(null, "", "?cc=" + selectedCard.value?.cardId);
//   emit("jumpStep", 1, "", 4);
// };

const back = () => {
  emit("jumpStep", 1, "", 4);
};

const handleNameKeyDown = (event: KeyboardEvent) => {
  const isSymbol = /^[a-zA-Z@#()_:\/.,'\-\s]+$/.test(event.key);
  const isDeleteKey = event.key === "Delete";
  const isBackspace = event.key === "Backspace";
  const isTabKey = event.key === " Tab";
  const isArrowKey = /^Arrow(Left|Right)$/.test(event.key);

  const isIOSArrowKey =
    event.key === "UIKeyInputLeftArrow" || event.key === "UIKeyInputRightArrow";
  const isAndroidArrowKey =
    event.key === "ArrowLeft" || event.key === "ArrowRight";

  if (
    !isSymbol &&
    !isBackspace &&
    !(isArrowKey || isIOSArrowKey || isAndroidArrowKey) &&
    !isDeleteKey &&
    !isTabKey
  ) {
    event.preventDefault();
  }
};

const handleEnterKey = () => {};
</script>
<style scoped>
/* .content {
      display: flex;
      margin-top: 40px;
      padding: 0 8%;
    } */

.container {
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  padding: 0;
  margin-bottom: 14px;
}

.flex_half {
  width: 50%;
}

.separator {
  margin-bottom: 37px;
  border-bottom: 1px solid #e4e4e4;
}

.flex_dropdown {
  display: flex;
  width: 30%;
  box-sizing: border-box;
  position: relative;
  display: inline-block;
}

.flex_inputText {
  width: 70%;
}

.right-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.left-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: 1px solid #cb03bc;
  background-color: white;
  font-size: 14px;
  font-weight: 500;
  color: #cb03bc;
  text-align: center;
  flex: 0 0 25%;
  cursor: pointer;
}

.right-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.full {
  width: 100%;
}

.line {
  border-bottom: 1px solid #e4e4e4;
}

.buttoncontainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
}

.left-button {
  flex: 0 0 15%;
}

.agree {
  display: flex;
  align-items: flex-start;
}

.flex_third {
  width: 30%;
}

.container3 {
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  padding: 0;
  margin-bottom: 14px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  will-change: transform, opacity;
  transform: translateZ(0);
  overflow-y: hidden;
  transition: top 0.3s;
}
.loading {
  margin-bottom: 0;
  font-family: "Outfit";
  color: white;
}
.spinner-border {
  width: 5rem;
  height: 5rem;
  color: white;
}
.flex-container {
  left: 0;
  margin: auto;
  position: absolute;
  text-align: center;
  top: 35%;
  right: 30%;
  left: 30%;
}

@media (max-width: 700px) {
  .container:is(.Desktop, .Tablet),
  .container3:is(.Desktop, .Tablet) {
    flex-direction: column;
    gap: 14px;
  }

  .flex_dropdown:is(.Desktop, .Tablet),
  .flex_inputText:is(.Desktop, .Tablet) {
    width: 100%;
  }
  .flex_half:is(.Desktop, .Tablet) {
    width: 100%;
  }

  .buttoncontainer:is(.Desktop, .Tablet) {
    gap: 10px;
  }

  .left-button:is(.Desktop, .Tablet) {
    flex: 0 0 30%;
  }

  .right-button:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .right-button:disabled:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .separator:is(.Desktop, .Tablet) {
    margin-bottom: 0;
  }

  /* .margin:is(.Desktop, .Tablet) {
        margin-bottom: 10px;
      } */

  .flex_third:is(.Desktop, .Tablet) {
    width: 100%;
  }
}

.inner {
  text-align: center;

  color: var(--Web-Black-High, #212121);
  text-align: center;
  /* Subtitle 1 (Medium) */
  font-family: Outfit;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 20.8px */
}

.container:is(.Mobile) {
  flex-direction: column;
}

.separator .container {
  max-width: none;
}

.content:is(.Mobile) {
  padding: 0;
}

.inner:is(.Mobile) {
  padding: 20px 20px 0 20px;
}

.container:is(.Mobile) {
  flex-direction: column;
  gap: 0;
}

.flex_dropdown:is(.Mobile),
.flex_inputText:is(.Mobile) {
  width: 100%;
}
.flex_half:is(.Mobile) {
  width: 100%;
}

.buttoncontainer:is(.Mobile) {
  gap: 10px;
  margin-bottom: 24px;
}

.left-button:is(.Mobile) {
  flex: 0 0 30%;
}

.right-button:is(.Mobile) {
  flex: 0 0 68%;
}

.right-button:disabled:is(.Mobile) {
  flex: 0 0 68%;
}

.separator:is(.Mobile) {
  margin-bottom: 0;
}

/* .margin:is(.Mobile) {
      margin-bottom: 10px;
    } */

.flex_third:is(.Mobile) {
  width: 30%;
}

.content {
  /* display: flex; */
  justify-content: center;
  margin: 0;
}

.top-up-successful,
.top-up-successful * {
  margin-top: 20px;
  box-sizing: border-box;
}

.top-up-successful {
  color: var(--primary-active, #ac2887);
  text-align: center;
  font: 500 20px/130% "outfit";
  position: relative;
  align-self: stretch;
}

.wallet-limit-up-to-m,
.wallet-limit-up-to-m * {
  box-sizing: border-box;
  margin-top: 16px;
  margin-bottom: 40px;
}

.wallet-limit-up-to-m {
  position: relative;
  align-self: stretch;
  padding: 0 100px;
  color: var(--Web-Black-low, #9e9e9e);
  text-align: center;
  /* Subtitle 1 (Medium) */
  font-family: Outfit;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 20.8px */
}

.wallet-limit-up-to-m:is(.Mobile) {
  padding: 0 30px;
}

.group-208 {
  height: auto;
  position: absolute;
  left: calc(50% - 11px);
  top: calc(50% - 12px);
  overflow: visible;
}

.refNo {
  color: var(--web-black-high, #212121);
  text-align: center;
  font-family: var(--h-3-font-family, "Outfit", sans-serif);
  font-size: var(--h-3-font-size, 18px);
  line-height: var(--h-3-line-height, 130%);
  font-weight: var(--h-3-font-weight, 500);
  position: relative;
  align-self: stretch;
  margin-top: 16px;
}

@media (max-width: 500px) {
}

.inner:is(.Mobile) {
  padding: 20px 20px 0 20px;
}

.popup-sign,
.popup-sign * {
  box-sizing: border-box;
}

.popup-sign {
  background: var(--alert-negative, #df0029);
  border-radius: 60px;
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  position: relative;
  margin: -30px auto 0 auto;
}
</style>
